import MicroModal from "micromodal";
import { trackEvent } from "@/js/helpers/tracking";

const PROACTIVE_CHAT_DIALOG_ID = "modal-proactive-chat";

/**
 * ProactiveV2 uses a native `<dialog id="modal-proactive-chat">` + `showModal()` so it
 * stacks in the browser top layer above other `showModal()` UIs (e.g. Bricks DetailsModal).
 * Legacy MicroModal.close is attempted only if no open native dialog is found.
 */
export const safeCloseMicroModalById = (modalId = PROACTIVE_CHAT_DIALOG_ID) => {
  if (typeof document === "undefined") return;
  const el = document.getElementById(modalId);
  if (el instanceof HTMLDialogElement && el.open) {
    try {
      el.close();
    } catch {
      /* noop */
    }
    document.body.style.overflow = "";
    return;
  }
  try {
    MicroModal.close(modalId);
  } catch {
    /* no MicroModal instance */
  }
};

/** @returns {boolean} whether `showModal()` ran */
export const openProactiveChatDialog = () => {
  if (typeof document === "undefined") return false;
  const el = document.getElementById(PROACTIVE_CHAT_DIALOG_ID);
  if (!(el instanceof HTMLDialogElement)) return false;
  try {
    if (!el.open) {
      el.showModal();
      document.body.style.overflow = "hidden";
    }
    return true;
  } catch {
    return false;
  }
};

export const trackProactiveChatModalOpened = () => {
  trackEvent({
    action: "elementViewed",
    data: {
      elementType: "MODAL",
      position: "PROACTIVE CHAT MODAL",
      text: "Open",
    },
  });
};
